<template>
  <h2 style="text-align: center">找回账号</h2>
  <div
    style="
      color: #a8a8a8;
      text-align: center;
      margin-bottom: 40px;
      cursor: pointer;
    "
    @click="toRegister"
  >
    还没有账号？点击前往注册
  </div>

  <el-form
    :model="forgotPwdForm"
    ref="ruleFormRef"
    :rules="rules"
    style="width: 360px;margin: 50px auto; 0"
  >
    <template v-if="steps === 0">
      <el-form-item prop="orgId">
        <el-select
          v-model="forgotPwdForm.orgId"
          class="m-2"
          placeholder="请选择注册类型"
          size="large"
          style="width: 100%"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item prop="mobile">
        <el-input
          v-model="forgotPwdForm.mobile"
          placeholder="请输入手机号"
          size="large"
        />
      </el-form-item>

      <el-form-item prop="msgCode">
        <el-col :span="14">
          <el-input
            v-model="forgotPwdForm.msgCode"
            placeholder="请输入验证码"
            size="large"
          ></el-input>
        </el-col>
        <el-col :span="10">
          <el-button
            type="primary"
            size="large"
            :loading="checkCodeBtn.loading"
            :disabled="checkCodeBtn.disabled"
            @click="getCheckCode(ruleFormRef)"
            style="width: 140px; margin-left: 8px"
          >
            {{ checkCodeBtn.text }}
          </el-button>
        </el-col>
      </el-form-item>

      <el-button
        type="primary"
        round
        style="width: 200px; margin: 40px 80px 0"
        @click="toNext(ruleFormRef)"
        >下一步</el-button
      >
    </template>
    <template v-if="steps === 1">
      <el-form-item prop="passwd">
        <el-input
          v-model="forgotPwdForm.passwd"
          placeholder="请输入密码"
          type="password"
          show-password
          size="large"
        />
      </el-form-item>

      <el-form-item prop="passwordConfirm">
        <el-input
          v-model="forgotPwdForm.passwordConfirm"
          placeholder="请确认密码"
          type="password"
          show-password
          size="large"
        />
      </el-form-item>

      <el-button
        type="primary"
        round
        style="width: 200px; margin: 40px 80px 0"
        @click="submitForm(ruleFormRef)"
        >保存密码</el-button
      >
    </template>

    <template v-if="steps === 2">
      <el-result
        icon="success"
        title="重置成功"
        sub-title="恭喜完成密码重置，点击前往登录"
      >
        <template #extra>
          <el-button
            type="success"
            round
            style="width: 200px; margin-top: 60px"
            @click="toLogin"
            >前往登录</el-button
          >
        </template>
      </el-result>
    </template>
  </el-form>
</template>

<script setup>
import { reactive, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getVerificationCode, checkMobile, checkMsgCode, updatePasswd } from "@request/login";
import { ElMessage } from "element-plus";
import { session_get, isMobile } from "@utils";
import { getDic } from "@request/common";

const router = useRouter();

const ruleFormRef = ref();
const steps = ref(0);
const forgotPwdForm = reactive({
  orgId: "",
  mobile: "",
  msgCode: "",
});
const checkCodeBtn = reactive({
  text: "获取验证码",
  loading: false,
  disabled: false,
  duration: 60,
  timer: null,
});

const validateMobile = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入手机号"));
  } else if (!isMobile(value)) {
    callback(new Error("请输入正确手机号码"));
  } else {
    callback();
  }
};

const validateRepwd = (rule, value, callback) => {
  if (value === "") {
    return callback(new Error("请再次输入密码"));
  } else if (value != forgotPwdForm.passwd) {
    callback(new Error("两次密码不一致"));
  } else {
    callback();
  }
};

const rules = reactive({
  orgId: [{ required: true, message: "请选择账号类型", trigger: "change" }],
  mobile: [{ trigger: "blur", validator: validateMobile }],
  msgCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
  passwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
  passwordConfirm: [{ trigger: "blur", validator: validateRepwd }],
});

const options = ref([]);

onMounted(() => {
  let typeDic = session_get("typeDic") || [];
  if (typeDic.length === 0) {
    getDic({ type: "1" }).then((res) => {
      typeDic = res.map((item) => {
        return {
          value: item.id + "",
          label: item.name,
        };
      });
      options.value = typeDic;
    });
  } else {
    options.value = typeDic;
  }
});

const toNext = (formEl) => {
  if (!formEl) return;
  formEl.validate((valid, fields) => {
    console.log(forgotPwdForm);
    if (valid) {
      // 验证验证码是否正确
      let params = {
        mobile: forgotPwdForm.mobile,
        msgCode: forgotPwdForm.msgCode
      }
      checkMsgCode(params).then(() => {
        steps.value = 1;
      })
    } else {
      console.log("error submit!", fields);
    }
  });
};

const submitForm = (formEl) => {
  if (!formEl) return;
  formEl.validate((valid, fields) => {
    if (valid) {
      console.log(forgotPwdForm);
      // 请求接口重置
      updatePasswd({...forgotPwdForm}).then(() => {
        steps.value = 2;
      })
    } else {
      console.log("error submit!", fields);
    }
  });
};

const getCheckCode = (formEl) => {
  // 验证手机号码
  formEl.validateField("mobile", (isPass) => {
    if (isPass) {
      // 通过表单校验之后,再验证手机号码和orgId信息
      checkMobile({ ...forgotPwdForm }).then(() => {
        getVerificationCode({
          mobile: forgotPwdForm.mobile,
        }).then(() => {
          ElMessage({
            message: "验证码已发送",
            type: "success",
          });
          // 验证码发送才能倒计时开始
          // 倒计时期间按钮不能单击
          if (checkCodeBtn.duration <= 60) {
            checkCodeBtn.disabled = true;
          }
          // 清除掉定时器
          checkCodeBtn.timer && clearInterval(checkCodeBtn.timer);
          // 开启定时器
          checkCodeBtn.timer = setInterval(() => {
            const tmp = checkCodeBtn.duration--;
            checkCodeBtn.text = `${tmp}秒`;
            if (tmp <= 0) {
              // 清除掉定时器
              clearInterval(checkCodeBtn.timer);
              checkCodeBtn.duration = 60;
              checkCodeBtn.text = "重新获取";
              // 设置按钮可以单击
              checkCodeBtn.disabled = false;
            }
          }, 1000);
        });
      });
    }
  });
};

const toRegister = () => {
  router.push({
    path: "/register",
  });
};

const toLogin = () => {
  router.push({
    path: "/login",
  });
};
</script>

<style lang="scss">
</style>
